import { Avatar, Box, Button, Typography } from '@mui/material';
import { fromNow } from '../utils/dateTimeUtils';
import { PostContent } from './PostContent';
import { Media } from '../../../../generated/graphql';
import { ReportReason, ReportReasonDictionary } from '../reportReasons';
import { ActionMenu } from './ActionMenu';

export type ReportedItem = {
  activityId: string;
  activityType: string;
  author: {
    id: number;
    profilePicture: string;
    username: string;
  };
  createdAt: string;
  id: number;
  parentId?: string;
  media?: Media[];
  reason: ReportReason;
  reportedBy: {
    id: number;
    profilePicture: string;
    username: string;
  };
  text: string;
};

type ContentOverviewProps = {
  item: ReportedItem;
  onDelete: () => void;
  onKeep: () => void;
  onBlock: () => void;
  onNavigate: () => void;
  isKeepProgress: boolean;
};

export const ContentOverview = ({
  item: { author, createdAt, text, media, reason, reportedBy, activityType },
  onDelete,
  onKeep,
  onBlock,
  onNavigate,
  isKeepProgress,
}: ContentOverviewProps) => (
  <Box className="bg-white p-[30px] rounded-2xl">
    <Box className="pb-5 mx-5 border-b cursor-pointer" onClick={onNavigate}>
      <b>{reportedBy.username}</b> reported on this <b>{activityType}</b> on{' '}
      <b>{author.username}</b>. Report reason: {ReportReasonDictionary[reason]}
    </Box>
    <Box className="flex flex-col justify-start gap-4 m-5 border-b">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2.5">
          <Avatar alt={author.username} src={author.profilePicture || ''} />
          <div className="flex flex-col justify-center">
            <div className="flex gap-1.5 items-center">
              <Typography variant="h6" sx={{ fontWeight: 800 }}>
                {author.username}
              </Typography>
            </div>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: '0.75rem',
                lineHeight: '0.938rem',
              }}
            >
              {fromNow(createdAt)}
            </Typography>
          </div>
        </div>
        <ActionMenu
          onDelete={onDelete}
          onBlock={onBlock}
          item="post"
          showBlockUser={true}
          userId={author.id}
          username={author.username}
          userProfilePicture={author.profilePicture}
        />
      </div>
      <Box className="pb-[18px]">
        <PostContent text={text} media={media || []} isPostPage={false} />
      </Box>
    </Box>
    <Box className="flex justify-end gap-5 pt-5">
      <Button
        variant="text"
        className="w-[176px]"
        onClick={onKeep}
        disabled={isKeepProgress}
      >
        Keep this {activityType === 'post' ? activityType : 'comment'}
      </Button>
      <Button variant="contained" className="w-[176px]" onClick={onDelete}>
        Delete
      </Button>
    </Box>
  </Box>
);
